import React from 'react';

const LANGS = ['English','Spanish','French','German','Italian','Japanese','Mandarin'];
const LEVELS = ['Beginner','Intermediate','Advanced','Beginner–Intermediate','Intermediate–Advanced'];

const FilterSidebar = ({ categories, activeCategory, onCategoryChange, language, onLanguageChange, level, onLevelChange, search, onSearchChange }) => {
  return (
    <div className="categories-sidebar">
      <h2>Browse</h2>
      <input
        value={search}
        onChange={(e)=>onSearchChange(e.target.value)}
        placeholder="Search titles..."
        className="search-input"
      />
      <ul className="category-list">
        {categories.map(c => (
          <li key={c.id}>
            <button
              className={`category-button ${activeCategory===c.id?'active':''}`}
              onClick={()=>onCategoryChange(c.id)}
            >{c.name}</button>
          </li>
        ))}
      </ul>
      <div className="filter-pills">
        <div className="pill-group">
          <label>Language</label>
          <div className="pills">
            {LANGS.map(l => (
              <button key={l} className={`pill ${language===l?'active':''}`} onClick={()=>onLanguageChange(language===l?'' : l)}>{l}</button>
            ))}
          </div>
        </div>
        <div className="pill-group">
          <label>Level</label>
          <div className="pills">
            {LEVELS.map(lv => (
              <button key={lv} className={`pill ${level===lv?'active':''}`} onClick={()=>onLevelChange(level===lv?'' : lv)}>{lv}</button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;
